const ACTIONS = {
    GET_DATA_ADMIN_USER_SUCCESS: 'GET_DATA_ADMIN_USER_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    ADD_ADMIN_USERS_SUCCESS: 'ADD_ADMIN_USERS_SUCCESS',
    ADD_ADMIN_USERS_ERROR: 'ADD_ADMIN_USERS_ERROR',
    UPDATE_ADMIN_USERS_SUCCESS : 'UPDATE_ADMIN_USERS_SUCCESS',
    UPDATE_ADMIN_USERS_ERROR : 'UPDATE_ADMIN_USERS_ERROR',
    DELETE_ADMIN_USERS_SUCCESS : 'DELETE_ADMIN_USERS_SUCCESS',
    DELETE_ADMIN_USERS_ERROR : 'DELETE_ADMIN_USERS_ERROR',
    GET_ROLES_SUCCESS : 'GET_ROLES_SUCCESS',
    GET_ROLES_ERROR : 'GET_ROLES_ERROR'
};

const header = ['名前', 'ログインID', '権限', '']
const dataAdminUsers = []

export default (state = { header, dataAdminUsers }, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_ADMIN_USER_SUCCESS:
            return {
                ...state,
                type: action.type,
                response: action.data.data,
                status:true,
                meta:action.data.meta
            };
        case ACTIONS.GET_DATA_ERROR:
            return {
                ...state,
                type: action.type,
                response: action.err,
                status:false
            }
        case ACTIONS.GET_ROLES_SUCCESS:
            return {
                ...state,
                response:action.data,
                type:action.type,
                status:true
            }
        case ACTIONS.ADD_ADMIN_USERS_SUCCESS:
            return {
                ...state,
                status: true,
                type:action.type,
                response:action.data,
                message : action.data.message
            }
        case ACTIONS.ADD_ADMIN_USERS_ERROR:
            return {
                ...state,
                status: false,
                message : action.data.message
            }
        case ACTIONS.UPDATE_ADMIN_USERS_SUCCESS:
            return {
                ...state,
                message : action.data.message,
                type : action.type,
                statusUpdate: true,
                status : true
            }
        case ACTIONS.UPDATE_ADMIN_USERS_ERROR:
            return {
                ...state,
                type : action.type,
                message : action.data.message,
                statusUpdate: true,
                status : true
            }
        case ACTIONS.DELETE_ADMIN_USERS_SUCCESS:
            return {
                ...state,
                type : action.type,
                message : action.data.message,
                statusDelete: true,
                status : true,
            }
        case ACTIONS.DELETE_ADMIN_USERS_ERROR:
            return {
                ...state,
                type : action.type,
                message : action.data.message,
                statusDelete: false,
                status : true,
            }    
            
        default:
            return state;
    }
};